import axios from "axios";
import { urlBase } from "../../Constante/Url";

const requestToken = (pre_auth_token) => {
  const url = `${urlBase}login/otp/request/`;
  const response = axios.post(url, pre_auth_token);
  return response;
};

export const loginRequest = { requestToken };
